export default {
    SET_NEWSPAPER_PDFS(state, newspaperPdfs) {
        state.newspaperPdfs = newspaperPdfs.items
        state.totalPages = newspaperPdfs.total_pages
    },
    ADD_NEWSPAPER_PDF(state, newspaperPdf) {
        state.newspaperPdfs.unshift(newspaperPdf)
    },
    DELETE_NEWSPAPER_PDF(state, newspaperPdfId) {
        const ItemIndex = state.newspaperPdfs.findIndex((u) => u.id === newspaperPdfId)
        state.newspaperPdfs.splice(ItemIndex, 1)
    },
    SET_NEWSPAPER_PDF_INFOS(state, newspaperPdf) {
        state.newspaperPdfInfos = newspaperPdf
    }
}
